function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "confluence-a",
  x1: "99.14%",
  x2: "33.859%",
  y1: "65.707%",
  y2: "46.933%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "18%",
  stopColor: "#0052CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2684FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "confluence-b",
  x1: ".926%",
  x2: "66.18%",
  y1: "34.304%",
  y2: "53.086%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "18%",
  stopColor: "#0052CC"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#2684FF"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#confluence-a)",
  d: "M2.894 58.541c-.825 1.346-1.752 2.908-2.54 4.153a2.54 2.54 0 0 0 .851 3.454l16.508 10.158a2.54 2.54 0 0 0 3.518-.863c.66-1.105 1.51-2.54 2.438-4.076 6.54-10.794 13.117-9.473 24.977-3.81l16.369 7.784a2.54 2.54 0 0 0 3.416-1.27l7.86-17.777a2.54 2.54 0 0 0-1.27-3.327 1994.577 1994.577 0 0 1-16.508-7.848C36.265 34.313 17.358 35.011 2.894 58.541z",
  transform: "translate(0 1)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#confluence-b)",
  d: "M76.913 18.198c.825-1.346 1.752-2.908 2.54-4.152a2.54 2.54 0 0 0-.851-3.454L62.094.433a2.54 2.54 0 0 0-3.619.838c-.66 1.105-1.511 2.54-2.438 4.077-6.54 10.793-13.118 9.473-24.978 3.81L14.742 1.41a2.54 2.54 0 0 0-3.416 1.27l-7.86 17.778a2.54 2.54 0 0 0 1.27 3.327 1994.583 1994.583 0 0 1 16.507 7.847c22.299 10.794 41.207 10.07 55.67-13.435z",
  transform: "translate(0 1)"
}));

var SvgConfluenceIco = function SvgConfluenceIco(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConfluenceIco, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/confluence_ico.1b87e831.svg";
export { ForwardRef as ReactComponent };